// @ts-nocheck
import React, { useContext, FC, PropsWithChildren } from 'react';
import { CTF_STATUS, ScoreboardContext, ScoreboardContextType } from '../ScoreboardProvider';
import { Droplet, TrophyFill } from 'react-bootstrap-icons';
import GridCell, { SimpleGridCell } from './GridCell';
import './Scoreboard.css';
import { CHECK_CODE } from '../ScoreboardProvider';
import { ThemeContext, ThemeContextType, ThemeEnum } from '../ThemeProvider';

const evaluateMsg = (notWorkingActions : {
    teamId: number,
    serviceId: number,
    action: string,
    exitCode: number,
    stdout: string
}[]) => {
    const debug = true
    //if(notWorkingActions[0].teamId === 0) console.log(notWorkingActions)
    const UI_TIP = new Map<string, string>([
        ["GET_FLAG", "GET: "],
        ["CHECK_SLA", "CHECK: "],
        ["PUT_FLAG", "PUT: "]
    ])
    return notWorkingActions?.map(t => UI_TIP.get(t.action) + t.stdout.toLowerCase() + ` [${debug === true ? t.exitCode : (t.exitCode > 100 ? t.exitCode : 110)}]`).join(",")
}



const Scoreboard : FC<PropsWithChildren> = () => {
    const { data, refresh } = useContext(ScoreboardContext) as ScoreboardContextType;
    const { theme } = useContext(ThemeContext) as ThemeContextType;
    // TODO: controllare che team e attackerid siano in sync
    // TODO: aggiungere chall_name
    // TODO: aggiungere i punti della chall
    if(data === null || data.game === null || data.teams === null || data.services === null) return null
    if(data.ctf_status === CTF_STATUS.NOT_STARTED) return null;
    return <div className={`scoreboardExt ${theme === ThemeEnum.light ? 'scoreboardExt-light' : ''}`}>
        <div className={`challMetaRow ${theme === ThemeEnum.light ? 'challMetaRow-light' : ''}`}>
        {
            data != null && (data.services != undefined && data.services != null && data.game?.checks != null) ? data.services.filter((s, id) => data.game?.checks.filter(f => f.serviceId === id)[0].exitCode !== CHECK_CODE.CHECKER_DISABLED).map((i, id) => {
                try{
                    id = data.services?.indexOf(i)                    
                }catch{}
                return <div className="challMetaCell" key={id}>
                    <span className="iat firstBlood">{data.game.first_bloods.filter(fb => fb.service_id === id).length > 0 ? <><Droplet />{data.teams.filter(f => f.teamId === data.game.first_bloods.filter(fb => fb.service_id === id)[0].attacker_id)[0].name}</> : <><Droplet style={{opacity:0}}/></>}</span>
                    <span className="challName">{i.name}</span>
                </div>
            }) : ''

        }
            <div className="challMetaCell">
                <span>King of the Hill</span>
            </div>
            <div className="challMetaCell">
                <span>Speedrun</span>
            </div>
        </div>
        {
            data != null && (data.teams != undefined || data.teams != null) ? data.teams.sort((t1, t2) => t2.full_score - t1.full_score).map((t, id) => {
                return <div key={id} className={`srow ${theme === ThemeEnum.light ? 'srow-light' : ''}`} >
                    <div className="metaWrapper">
                        <span className="pos">{id + 1}.</span>
                        <div className="metadata">
                            {
                                t.logo === "logo" ? <div style={{backgroundColor: "white", width: "3rem", height: "3rem"}} className="avatar"/> : <img src={t.logo} style={{width: "3rem", height: "3rem"}} className="avatar" />
                            }
                             
                            <span className="teamName">{t.name}</span>
                            <span className="pts">{t.full_score}</span>
                        </div>   
                    </div>
                    {
                        data.game.score.filter(s => s.teamId === t.teamId && data.game?.checks.filter(f => f.serviceId === s.serviceId)[0].exitCode !== CHECK_CODE.CHECKER_DISABLED).sort((a, b) => a.serviceId - b.serviceId).map(s => {
                            const sla_entry = data.game.sla.filter(sla => sla.teamId === t.teamId && sla.serviceId === s.serviceId)[0]
                            const uptime = Math.round((sla_entry === undefined || sla_entry.totalChecks === 0 ? 1 : sla_entry.successfulChecks / sla_entry.totalChecks)*100*100)/100
                            const notWorkingActions = data.game?.checks.filter(t => t.serviceId == s.serviceId && t.teamId == s.teamId && t.exitCode != CHECK_CODE.OK)
                            const ok = notWorkingActions.length === 0 
                            if(notWorkingActions?.filter(t => t.exitCode == CHECK_CODE.CHECKER_DISABLED) === 3) return null; // hide if all are hidden
                            return <div className="scol" key={id + ":" + s.serviceId}><GridCell totPts={s.score} roundPts={s.stolen} lostPts={s.lost} uptime={uptime} sla_info={sla_entry != null ? [sla_entry.successfulChecks, sla_entry.totalChecks] : [0, 0]} chkError={notWorkingActions?.filter(f => f.exitCode === CHECK_CODE.ERROR || !Object.values(CHECK_CODE).includes(f.exitCode)).length > 0} status={{ok: data.ctf_round < 1 || ok, msg: data.ctf_round < 1 || ok ? 'OK.' : evaluateMsg(notWorkingActions)}}/></div>
                        })
                    }
                    <div className="scol">
                        <SimpleGridCell totPts={t.teamId != 0 ? data.koth?.filter(s => s.teamId == t.teamId)[0].score : 0} />
                    </div>
                    <div className="scol">
                        <SimpleGridCell totPts={data.speedrun?.filter(s => s.teamId == t.teamId)[0].score} />
                    </div>
                </div> 
            }) : ''
        }
    </div>
}

export default Scoreboard;